import React from "react";
import Injecter from "../Modules/Injecter";

export class HelpscoutBeacon extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const id = this.props.id || "";

    Injecter.injectBodyScript({
      body: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`,
      tag: "helpscout-beacon-core",
    });
    Injecter.injectBodyScript({
      body: `window.Beacon('init', '${id}')`,
      tag: "helpscout-beacon-init",
    });
  }

  render() {
    return null;
  }
}

export default HelpscoutBeacon;
